import { getLocale } from "../runtime";

const sv_skcountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Slovakien`
};

const skcountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_skcountry(inputs)
	return "skCountry";
};

export { skcountry as "skCountry" };